import * as yup from "yup";
import { VALIDATION_REGEX } from "utils/constants";
import i18next from "config/i18next";
import "./i18n";

export const validationSchema = yup.object({
  code: yup
    .string()
    .min(6, i18next.t("filterTemplates:invalidCodeError"))
    .matches(
      VALIDATION_REGEX.regTransactionCode,
      i18next.t("filterTemplates:invalidCodeError")
    ),
});
